import { isNil } from "lodash";
import { FormControl, FormGroup } from "react-bootstrap";
import { greyPalette } from "../../helpers/constants/colorPalettes";
import * as colors from "../../helpers/constants/colors";
import React, { PureComponent } from "react";
import Dropzone from "react-dropzone";
import * as configureWevoActions from "../../modules/configure-wevo/actions";
import CircularProgress from "material-ui-old/CircularProgress";
import IconMenu from "material-ui-old/IconMenu";
import MenuItem from "material-ui-old/MenuItem";
import IconButton from "material-ui-old/IconButton";
import MoreHorizIcon from "material-ui-old/svg-icons/navigation/more-horiz";
import Remove from "material-ui-old/svg-icons/content/remove";
import Delete from "material-ui-old/svg-icons/action/delete";
import Flag from "material-ui-old/svg-icons/image/assistant-photo";
import ToothpasteTag from "../ToothpasteTag";
import Icon from "../Icon";

import { trackerActions } from "../../modules/tracker/index";
import { connect } from "react-redux";
import { ConfigureProjectEvents } from "../../modules/tracker/event-names/index";

export class ImageCard extends PureComponent {
    static PAGE_INDICES = ["A", "B", "C", "D", "E", "F"];

    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            pageName: this.props.page.name
        };
    }

    componentWillReceiveProps(nextProps) {
        const { page, wevoId, pageId } = nextProps;
        if (pageId && !page) {
            configureWevoActions.fetchPage(wevoId, pageId);
        }
        this.setState({
            pageName: page.name
        });
    }

    onDrop(acceptedFiles, rejectedFiles) {}

    renderTag(text, color) {
        return (
            <ToothpasteTag className="pull-left" label={text} color={color} />
        );
    }

    handleHover(hovered) {
        this.setState({
            hovered: hovered && !this.props.isReadOnly
        });
    }

    handleNameChange(e) {
        const name = e.target.value;
        this.setState({
            pageName: name
        });
    }

    closeMenu() {}

    renderImage(page) {
        const hasContent = page && (page.id || this.props.errorState);
        if (!hasContent) {
            return <CircularProgress />;
        }

        if (this.props.errorState) {
            return this.renderError();
        }

        const { image } = page;
        return (
            <div
                style={{
                    height: "100%",
                    overflow: "hidden",
                    width: "100%",
                    backgroundImage: `url(${image.files.original.imageUrl})`,
                    backgroundSize: "cover"
                }}
            />
        );
    }

    renderError() {
        return (
            <div
                style={{
                    height: "100%",
                    overflow: "hidden",
                    width: "100%",
                    backgroundColor: greyPalette.medLtGrey,
                    display: "flex"
                }}
            >
                <div
                    style={{
                        height: "75%",
                        width: "75%",
                        display: "flex",
                        flexDirection: "column",
                        margin: "auto"
                    }}
                >
                    <div
                        style={{
                            color: colors.error,
                            margin: "auto",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around"
                        }}
                    >
                        <Icon
                            icon="exclamation-triangle"
                            style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                                marginRight: "5px",
                                fontSize: "1.3rem"
                            }}
                        />
                        <h5
                            style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                                marginLeft: "5px"
                            }}
                        >
                            Error Uploading Page
                        </h5>
                    </div>
                    <div
                        style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            marginTop: "10px"
                        }}
                    >
                        <span>
                            Please check your internet connection and try again.
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    removePage() {
        const { page } = this.props;
        if (page.id) {
            this.props.trackEvent(
                ConfigureProjectEvents.DID_ATTEMPT_PAGE_REMOVAL,
                {
                    page_id: page.id,
                    page_name: page.name
                }
            );
        } else {
            this.props.trackEvent(
                ConfigureProjectEvents.DID_REMOVE_UPLOAD_ERROR_CARD
            );
        }
        this.props.removePage();
    }

    updateName(e) {
        const name = e.target.value;
        this.update({
            name
        });
    }

    update(properties) {
        const { page } = this.props;
        if (page.id) {
            this.props.setProperties(page.id, properties);
        }
    }

    render() {
        const { page, isReadOnly } = this.props;
        if (!page) {
            return <CircularProgress />;
        }

        return (
            <Dropzone
                ref="dropzoneElement"
                onMouseOver={this.handleHover.bind(this, true)}
                onMouseOut={this.handleHover.bind(this, false)}
                onDrop={this.onDrop.bind(this)}
                maxSize={5000000}
                multiple={false}
                disableClick={true}
                accept="image/png,image/x-png,image/gif,image/jpeg"
                style={{
                    width: "100%",
                    height: "100%",
                    padding: `0px`,
                    border: "none",
                    backgroundColor: this.state.hovered
                        ? greyPalette.lightGrey
                        : colors.white
                }}
            >
                <div
                    style={{
                        height: "100%",
                        width: "100%",
                        padding: "1% 2%"
                    }}
                >
                    <div
                        style={{
                            height: "5%",
                            width: "100%",
                            margin: "auto",
                            padding: "0% 7.5%"
                        }}
                    >
                        {!isReadOnly && (
                            <IconButton
                                iconStyle={{
                                    color: this.state.hovered
                                        ? colors.typography
                                        : colors.white,
                                    cursor: "pointer"
                                }}
                                onClick={this.removePage.bind(this)}
                                disableTouchRipple={true}
                                className="pull-left"
                            >
                                <Delete />
                            </IconButton>
                        )}
                        {!isReadOnly && (
                            <IconMenu
                                className="pull-right"
                                iconButtonElement={
                                    <IconButton
                                        disableTouchRipple={true}
                                        iconStyle={{
                                            color: this.state.hovered
                                                ? colors.typography
                                                : greyPalette.medGrey
                                        }}
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>
                                }
                                anchorOrigin={{
                                    horizontal: "right",
                                    vertical: "top"
                                }}
                                targetOrigin={{
                                    horizontal: "right",
                                    vertical: "top"
                                }}
                            >
                                {page.id && (
                                    <MenuItem
                                        onClick={this.update.bind(this, {
                                            isBaseline: !page.isBaseline
                                        })}
                                        disableTouchRipple={true}
                                        primaryText={
                                            page.isBaseline
                                                ? "Unmark as Baseline"
                                                : "Mark as Baseline"
                                        }
                                        leftIcon={<Remove />}
                                    />
                                )}
                                {page.id && (
                                    <MenuItem
                                        onClick={this.update.bind(this, {
                                            isCompetitor: !page.isCompetitor
                                        })}
                                        disableTouchRipple={true}
                                        primaryText={
                                            page.isCompetitor
                                                ? "Unmark as Competitor"
                                                : "Mark as Competitor"
                                        }
                                        leftIcon={<Flag />}
                                    />
                                )}
                                <MenuItem
                                    onClick={this.removePage.bind(this)}
                                    disableTouchRipple={true}
                                    primaryText="Delete"
                                    leftIcon={<Delete />}
                                />
                            </IconMenu>
                        )}
                    </div>
                    <div
                        style={{
                            height: "60%",
                            width: "85%",
                            margin: "auto",
                            padding: "0% 0%"
                        }}
                    >
                        {this.renderImage(page)}
                    </div>
                    <div
                        style={{
                            height: "17%",
                            width: "100%",
                            padding: "0% 7.5%",
                            margin: "auto",
                            marginTop: "10%"
                        }}
                    >
                        <div
                            style={{
                                height: "100%"
                            }}
                        >
                            <div
                                style={{
                                    height: "100%",
                                    padding: "5% 0%"
                                }}
                            >
                                <form style={{ margin: 0 }}>
                                    <FormGroup controlId="pageName">
                                        <FormControl
                                            disabled={
                                                isNil(page.id) || isReadOnly
                                            }
                                            type="text"
                                            value={this.state.pageName}
                                            placeholder="Enter text"
                                            onChange={this.handleNameChange.bind(
                                                this
                                            )}
                                            onBlur={this.updateName.bind(this)}
                                        />
                                    </FormGroup>
                                </form>
                            </div>
                            <div
                                style={{
                                    marginTop: "2%",
                                    height: "40%"
                                }}
                            >
                                {page.isBaseline
                                    ? this.renderTag(
                                          "BASELINE",
                                          greyPalette.darkGrey
                                      )
                                    : null}
                                {page.isCompetitor
                                    ? this.renderTag(
                                          "COMPETITOR",
                                          colors.warning
                                      )
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </Dropzone>
        );
    }
}

ImageCard.defaultProps = {
    errorState: false,
    error: ""
};

const mapDispatchToProps = dispatch => {
    return {
        trackEvent: (eventName, eventProperties) =>
            dispatch(trackerActions.trackEvent(eventName, eventProperties))
    };
};

export default connect(
    null,
    mapDispatchToProps
)(ImageCard);



// WEBPACK FOOTER //
// ./src/components/CreateTest/ImageCard.js